if (!customElements.get('collection-campaign-banner')) {
  class CollectionCampaignBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-campaign-track]');
      this.slides = Array.from(this.querySelectorAll('[data-campaign-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-campaign-dot]'));
      this.previousButton = this.querySelector('[data-campaign-previous]');
      this.nextButton = this.querySelector('[data-campaign-next]');
      this.activeIndex = 0;

      this.syncCollectionImage();

      if (!this.track || this.slides.length < 2) return;

      this.handlePrevious = () => this.showSlide(this.activeIndex - 1, true);
      this.handleNext = () => this.showSlide(this.activeIndex + 1, true);
      this.handleMouseEnter = () => this.stopAutoplay();
      this.handleMouseLeave = () => this.startAutoplay();
      this.handleFocusIn = () => this.stopAutoplay();
      this.handleFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      };

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.showSlide(index, true));
      });
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);

      this.showSlide(0, false);
      this.startAutoplay();
    }

    syncCollectionImage() {
      if (!this.id.includes('__image_zycLeD')) return;

      const image = this.querySelector('[data-campaign-slide] img');
      const collectionImageMeta = document.querySelector(
        'meta[property="og:image:secure_url"], meta[property="og:image"]'
      );
      if (!image || !collectionImageMeta?.content) return;

      const collectionImageUrl = new URL(collectionImageMeta.content, window.location.href);
      collectionImageUrl.protocol = 'https:';
      const widths = [640, 960, 1280, 1600, 1914];

      image.src = this.collectionImageUrlForWidth(collectionImageUrl, 1280);
      image.srcset = widths
        .map((width) => `${this.collectionImageUrlForWidth(collectionImageUrl, width)} ${width}w`)
        .join(', ');
      image.sizes = '100vw';
      image.alt = document.querySelector('meta[property="og:title"]')?.content || image.alt;
    }

    collectionImageUrlForWidth(url, width) {
      const sizedUrl = new URL(url);
      sizedUrl.searchParams.set('width', String(width));
      return sizedUrl.toString();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
    }

    showSlide(index, restartAutoplay) {
      this.activeIndex = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translate3d(-${this.activeIndex * 100}%, 0, 0)`;

      this.slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== this.activeIndex));
      });
      this.dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', String(dotIndex === this.activeIndex));
      });

      if (restartAutoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (
        this.dataset.autoplay !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        this.autoplayTimer
      ) {
        return;
      }

      const seconds = Number(this.dataset.autoplaySeconds) || 5;
      this.autoplayTimer = window.setInterval(() => {
        this.showSlide(this.activeIndex + 1, false);
      }, seconds * 1000);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  customElements.define('collection-campaign-banner', CollectionCampaignBanner);
}
